import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { StatusColor } from 'src/app/shared/status-indicator/status-indicator.component';
import { CohortStatus } from '../services/cohort.service';

@Component({
  selector: 'dcc-cohort-status-indicator',
  template: `<dcc-status-indicator
    [color]="indicatorColor"
    [value]="status"
  ></dcc-status-indicator>`,
  standalone: true,
  imports: [SharedModule],
})
export class CohortStatusIndicatorComponent implements OnInit, OnChanges {
  @Input() status: CohortStatus;
  indicatorColor: StatusColor;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['status']) {
      this.indicatorColor = this.getStatusColor(this.status);
    }
  }

  ngOnInit(): void {
    this.indicatorColor = this.getStatusColor(this.status);
  }

  private getStatusColor(status: CohortStatus): StatusColor {
    switch (status) {
      case CohortStatus.Enabled:
        return StatusColor.green;
      case CohortStatus.Disabled:
        return StatusColor.red;
      default:
        return StatusColor.yellow;
    }
  }
}
